<template>
    <section class="boostNew">
      <h3 class="title boostNew__title">{{$t('qic_landing_boost_header')}}</h3>
      <div class="boostNew__desc">{{$t('qic_landing_boost_desc')}}</div>
      <div class="boostNew__grid">
        <LandingBoostItem
          v-for="(additional, index) of additionals_"
          @toggleExpand="toggleItem(index)"
          :key="index"
          :name="additional[nameKey]"
          :show="additional[showKey]"
          :content="additional[contentKey]"/>
      </div>
    </section>
</template>

<script>
import LandingBoostItem from './LandingBoostItem.vue'

export default {
  name: 'LandingBoost',
  props: {
    additionals: { type: Array },
    contentKey: { type: String, default: 'content' },
    nameKey: { type: String, default: 'name' },
    showKey: { type: String, default: 'expanded' }
  },
  components: {
    LandingBoostItem
  },
  data () {
    return {
      additionals_: []
    }
  },
  methods: {
    toggleItem (id) {
      this.additionals_ = this.additionals_.map((i, index) => {
        if (index === id) i.expanded = !i.expanded
        else i.expanded = false
        return i
      })
    },
    initAdditionalList () {
      this.additionals_ = this.additionals.map(i => {
        i.expanded = false
        return i
      })
    }
  },
  mounted () {
    this.initAdditionalList()
  }
}
</script>
